export default "__VITE_ASSET__CdUUwIJd__"